import React, { FC, useEffect } from 'react';

import scriptLoader from './scriptLoader';

const Content: FC<React.PropsWithChildren> = ({ children }) => {
    useEffect(() => {
        scriptLoader(document);
    }, []);
    return <div className="sgw-content">{children}</div>;
};

export default Content;
